<style scoped>

</style>

<template>
  <component :is="componentModel" :src="stringSource" :controllable="controllable"></component>
</template>

<script>

// Library
import { ModelStl, ModelObj, ModelThree, ModelCollada, ModelPly, ModelGltf } from 'vue-3d-model'

export default {
  name: 'ModelItem',
  components: {
    ModelStl, ModelObj, ModelThree, ModelCollada, ModelPly, ModelGltf
  },
  props: {
    media: {
      type: Object,
      required: true
    },
    controllable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // String
    stringSource() {
      return this.media.content;
    },
    componentModel() {
      return "model-" + this.media.type;
    },
  },
  mounted() {

  },
  methods: {

  },
}
</script>
